// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* APIConfigIndex.module.css */

.APIConfigIndex_container__xsuCG {
  width: 100%;
  padding: 20px 0px;
  min-height: 700px;
}

/* ========== AUTHORIZATION SERVER SECTION ========== */
.APIConfigIndex_authServerSection__d8QmP {
  border: 2px solid #bbd8ff;
  border-radius: 6px;
  padding: 24px;
  margin-bottom: 32px;
  background: #d9e9ff;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.APIConfigIndex_authServerSection__d8QmP:hover {
  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.15);
  transform: translateY(-2px);
}

.APIConfigIndex_authServerHeader__-DMpZ {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.APIConfigIndex_authServerTitle__Fool9 {
  color: #1a1614;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.APIConfigIndex_authServerDescription__Tjk23 {
  margin-bottom: 20px;
  font-size: 0.875rem;
  color: #5f6368;
  line-height: 1.5;
}

.APIConfigIndex_authServerDescription__Tjk23 code {
  background-color: #f1f3f4;
  padding: 2px 6px;
  border-radius: 6px;
  font-family: "Courier New", monospace;
  font-size: 0.813rem;
  color: #ff32cc;
}
.APIConfigIndex_extraInfo__8aTBB {
  font-size: 13px;
  color: var(--subheading);
}
.APIConfigIndex_authServerCurrent__orUjp {
  background-color: #ffffff;
  padding: 16px;
  border-radius: 12px;
  /* margin-bottom: 12px; */
  border: 1px solid #ffe0b2;
  transition: all 0.2s ease;
}

.APIConfigIndex_authServerCurrent__orUjp:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.APIConfigIndex_authServerInfo__KPnRT {
  margin-bottom: 12px;
  color: #202124;
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
}
.APIConfigIndex_authServerInfo__KPnRT strong {
  background: transparent;
  background: transparent;
  color: #333;
  max-width: 100%;
  padding-bottom: 20px;
}

.APIConfigIndex_authServerActions__Jc-5L {
  display: inline-flex;
  gap: 10px;
  margin-top: 20px;
}

.APIConfigIndex_authEditButton__I-jeF {
  padding: 8px 20px;
  background: var(--editBtn);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.APIConfigIndex_authEditButton__I-jeF:hover {
  background: var(--editHover);
}

.APIConfigIndex_authDeleteButton__ARQgp {
  padding: 8px 20px;
  background: var(--deleteBtn);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.APIConfigIndex_authDeleteButton__ARQgp:hover {
  background: var(--deleteHover);
}

.APIConfigIndex_createAuthButton__MLmYy {
  padding: 12px 24px;
  /* background: linear-gradient(135deg, #ff9800 0%, #fb8c00 100%); */
  background: var(--gradient-primary);
  color: var(--white-color);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.APIConfigIndex_createAuthButton__MLmYy:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 119, 255, 0.3);
}

/* ========== MODAL EDITORS ========== */
.APIConfigIndex_authEditorModal__ZPCjG,
.APIConfigIndex_configEditorModal__lQ3MQ {
  border: 1px solid #e8eaed;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  background: var(--white-color);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

.APIConfigIndex_authEditorModal__ZPCjG {
  border-left: 4px solid #ff9800;
}

.APIConfigIndex_configEditorModal__lQ3MQ {
  border-left: 4px solid #1a73e8;
}

.APIConfigIndex_modalTitle__oAamI {
  font-size: 1.25rem;
  font-weight: 600;
  color: #202124;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8eaed;
}

.APIConfigIndex_curlImportSection__sYqgx {
  margin-bottom: 20px;
}

.APIConfigIndex_curlToggleButton__7z8\\+I {
  padding: 8px 16px;
  background: #f1f3f4;
  color: #328bff;
  border: 2px solid #bbd8ff;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.813rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.APIConfigIndex_curlToggleButton__7z8\\+I:hover {
  background: rgb(187, 214, 255);
  color: #202124;
}

.APIConfigIndex_formGroup__0FBvX {
  margin-bottom: 20px;
}

.APIConfigIndex_formLabel__J-zq4 {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #5f6368;
  font-size: 0.875rem;
  padding: 20px 0px;
}

.APIConfigIndex_textarea__nfIVY {
  width: 100%;
  padding: 12px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: inherit;
  transition: all 0.2s ease;
  resize: vertical;
  background: #f8f9fa;
}

.APIConfigIndex_textarea__nfIVY:focus {
  outline: none;
  border-color: #1a73e8;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.APIConfigIndex_selectInput__WgR71 {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 0.875rem;
  background-color: white;
  transition: all 0.2s ease;
}

.APIConfigIndex_selectInput__WgR71:focus {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

.APIConfigIndex_modalActions__vNI8q {
  margin-top: 24px;
  display: flex;
  gap: 12px;
  justify-items: flex-end;
  flex-direction: row-reverse;
}

.APIConfigIndex_saveButton__Feifq {
  padding: 10px 24px;
  background: var(--saveBtn);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

.APIConfigIndex_saveButton__Feifq:hover {
  background: var(--saveHover);
}

.APIConfigIndex_cancelButton__BQJRE {
  padding: 10px 24px;
  background: lightgray;
  color: #333;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

.APIConfigIndex_cancelButton__BQJRE:hover {
  background: rgb(176, 176, 176);
}

/* ========== REGULAR CONFIGURATIONS SECTION ========== */
/* .regularConfigsSection {
  margin-top: 16px;
} */

.APIConfigIndex_configsHeader__PydBO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  /* padding: 20px; */
  /* background: white; */
  border-radius: 12px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  flex-wrap: wrap;
  gap: 15px;
}

.APIConfigIndex_configsTitle__OysUS {
  font-size: 1.2rem;
  font-weight: 600;
  color: #202124;
  margin: 0;
}
.APIConfigIndex_configsmainTital__IhsL- {
  text-align: left;
  font-size: 1.2rem;
  font-weight: 600;
  color: #202124;
  margin-bottom: 15px;
}
.APIConfigIndex_createConfigButton__klZ5p {
  padding: 10px 24px;
  background-color: var(--saveBtn);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.APIConfigIndex_createConfigButton__klZ5p:hover {
  background: var(--saveHover);
}

.APIConfigIndex_configsList__dgDh5 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.APIConfigIndex_configCard__KUpMs {
  background: var(--white-color);
  border: 1px solid #e8eaed;
  border-radius: 16px;
  padding: 20px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.APIConfigIndex_configCard__KUpMs:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #dadce0;
}

.APIConfigIndex_configCardHeader__3lZsp {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.APIConfigIndex_configInfo__d-nCN {
  flex: 1 1;
}

.APIConfigIndex_configId__I57eJ {
  font-weight: 600;
  color: #202124;
  margin-bottom: 4px;
  font-size: 0.875rem;
  font-family: "Courier New", monospace;
  background: #f1f3f4;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
}

.APIConfigIndex_configEndpoint__7Wxrs {
  font-size: 0.875rem;
  margin-top: 6px;
}

.APIConfigIndex_configUrl__GhAn9 {
  color: #5f6368;
  font-family: "Courier New", monospace;
}

.APIConfigIndex_configMethod__0OnRy {
  color: #1a73e8;
  font-weight: 600;
  margin-left: 4px;
}

.APIConfigIndex_configActions__iJsCb {
  display: flex;
  gap: 8px;
}

.APIConfigIndex_editButton__5W91a {
  width: 40px;
  height: 40px;
  background: var(--editBtn);
  color: var(--white-color);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
}

.APIConfigIndex_editButton__5W91a:hover {
  background: var(--editHover);
}

.APIConfigIndex_deleteButton__\\+a\\+sX {
  width: 40px;
  height: 40px;
  background: var(--deleteBtn);
  color: var(--white-color);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
}

.APIConfigIndex_deleteButton__\\+a\\+sX:hover {
  background: var(--deleteHover);
}

.APIConfigIndex_configDetails__A4\\+T3 {
  /* margin-top: 16px; */
  padding: 16px 0px;
  /* border-top: 1px solid #e8eaed; */
}

.APIConfigIndex_configSummary__BJ4Ya {
  cursor: pointer;
  color: #1a73e8;
  font-weight: 500;
  font-size: 0.95rem;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  transition: all 0.2s ease;
}

.APIConfigIndex_configSummary__BJ4Ya:hover {
  color: #1557b0;
  text-decoration: underline;
}

.APIConfigIndex_configPre__djU1h {
  font-size: 0.875rem;
  white-space: pre-wrap;
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-top: 12px;
  border: 1px solid #e8eaed;
  overflow-x: auto;
  font-family: "Courier New", monospace;
  color: #202124;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.APIConfigIndex_emptyState__9P0OY {
  text-align: center;
  padding: 60px 40px;
  background: var(--white-color);
  border: 1px solid #e2e2e2;
  border-radius: 6px;
  transition: border-color 0.2s ease;
  width: 100%;
  margin-bottom: 20px;
  box-shadow: var(--shadow-md);
}

.APIConfigIndex_emptyState__9P0OY p {
  color: #5f6368;
  font-size: 1rem;
  margin: 0;
}

/* ========== LOADING STATE ========== */
.APIConfigIndex_loadingContainer__QF\\+z5 {
  padding: 60px;
  text-align: center;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.APIConfigIndex_loadingSpinner__4IIxc {
  display: inline-block;
  width: 48px;
  height: 48px;
  border: 4px solid #f1f3f4;
  border-top: 4px solid #1a73e8;
  border-radius: 50%;
  animation: APIConfigIndex_spin__rlxEY 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes APIConfigIndex_spin__rlxEY {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.APIConfigIndex_loadingText__yVqjY {
  font-size: 16px;
  color: #5f6368;
  font-weight: 500;
}

/* ========== ANIMATIONS ========== */
@keyframes APIConfigIndex_slideIn__HaXP0 {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.APIConfigIndex_authEditorModal__ZPCjG,
.APIConfigIndex_configEditorModal__lQ3MQ {
  animation: APIConfigIndex_slideIn__HaXP0 0.3s ease-out;
}

@keyframes APIConfigIndex_fadeIn__NBSde {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.APIConfigIndex_configCard__KUpMs,
.APIConfigIndex_authServerCurrent__orUjp {
  animation: APIConfigIndex_fadeIn__NBSde 0.3s ease-out;
}
.APIConfigIndex_customSelect__jUZhd {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px;
  cursor: pointer;
}

.APIConfigIndex_customSelect__jUZhd::-ms-expand {
  display: none;
}

.APIConfigIndex_customSelect__jUZhd::-ms-expand {
  display: none;
}

.APIConfigIndex_selectWrapper__9-leH {
  position: relative;
  display: inline-block;
  width: 100%;
}

.APIConfigIndex_selectIcon__f0Onz {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
}

/* Add to APIConfigIndex.module.css */
.APIConfigIndex_placeholderMessage__HNoE- {
  padding: 60px 20px;
  text-align: center;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
  margin: 20px 0;
}

.APIConfigIndex_placeholderIcon__Wbd0l {
  font-size: 48px;
  display: block;
  margin-bottom: 16px;
}

.APIConfigIndex_placeholderMessage__HNoE- h4 {
  font-size: 18px;
  color: #333;
  margin: 0 0 12px 0;
}

.APIConfigIndex_placeholderMessage__HNoE- p {
  font-size: 16px;
  color: #495057;
  margin: 0;
}
.APIConfigIndex_tittleWrap__krEZ- {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.APIConfigIndex_tittleWrap__krEZ- span {
  cursor: help;
  color: rgb(102, 102, 102);
  font-size: 14px;
}

.APIConfigIndex_infoIcon__nIMBZ {
  margin-left: 10px;
  cursor: help;
  color: #666;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

/* Tooltip container */
.APIConfigIndex_infoIcon__nIMBZ .APIConfigIndex_tooltipText__xfqDO {
  visibility: hidden;
  width: 300px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.4;

  /* Position */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);

  /* Animation */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.APIConfigIndex_infoIcon__nIMBZ .APIConfigIndex_tooltipText__xfqDO::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

/* Show tooltip on hover */
.APIConfigIndex_infoIcon__nIMBZ:hover .APIConfigIndex_tooltipText__xfqDO {
  visibility: visible;
  opacity: 1;
}
.APIConfigIndex_createTemplateButton__2uRn0 {
  padding: 12px;
  background-color: rgb(55, 151, 254);
  color: white;
  border: medium;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 8px;
}
.APIConfigIndex_viewAllTemplatesButton__zzvdp {
  padding: 12px;
  background-color: rgb(56, 161, 105);
  color: white;
  border: medium;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-right: 8px;
}
.APIConfigIndex_actionsWrap__FI1\\+d {
  margin-top: 20px;
}

/* Add these styles to your module.css */
.APIConfigIndex_curlImportSection__sYqgx {
  position: relative;
  margin-bottom: 16px;
}

.APIConfigIndex_curlToggleButton__7z8\\+I {
  /* Your existing button styles */
  position: relative;
  z-index: 1;
}

.APIConfigIndex_curlOverlay__K2ITb {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.APIConfigIndex_curlOverlayContent__r2GPG {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.APIConfigIndex_curlOverlayClose__Unj8F {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
}

.APIConfigIndex_curlOverlayClose__Unj8F:hover {
  background: #f0f0f0;
  color: #333;
}
/* ========== RESPONSIVE DESIGN ========== */
@media (max-width: 768px) {
  .APIConfigIndex_container__xsuCG {
    padding: 0px;
    overflow-x: hidden;
  }

  .APIConfigIndex_authServerSection__d8QmP {
    padding: 16px 10px;
  }
  .APIConfigIndex_authServerInfo__KPnRT {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .APIConfigIndex_configsHeader__PydBO {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .APIConfigIndex_configCardHeader__3lZsp {
    flex-direction: column-reverse;
    align-items: flex-start;
    align-items: end;
  }

  .APIConfigIndex_configActions__iJsCb {
    /* width: 100%; */
    margin-bottom: 20px;
  }

  .APIConfigIndex_editButton__5W91a,
  .APIConfigIndex_deleteButton__\\+a\\+sX {
    flex: 1 1;
    text-align: center;
  }

  .APIConfigIndex_authServerActions__Jc-5L {
    flex-direction: column;
  }

  .APIConfigIndex_authEditButton__I-jeF,
  .APIConfigIndex_authDeleteButton__ARQgp {
    width: 100%;
    text-align: center;
    padding: 8px 20px;
    font-size: 0.745rem;
  }

  .APIConfigIndex_modalActions__vNI8q {
    flex-direction: column;
  }

  .APIConfigIndex_saveButton__Feifq,
  .APIConfigIndex_cancelButton__BQJRE {
    width: 100%;
    text-align: center;
  }

  .APIConfigIndex_metadata__DjElj {
    flex-direction: column;
    gap: 8px;
  }
  .APIConfigIndex_actionsWrap__FI1\\+d {
    display: flex;
    gap: 10px;
    flex-direction: column;
  }
  .APIConfigIndex_infoIcon__nIMBZ .APIConfigIndex_tooltipText__xfqDO {
    transform: translateX(-100%);
  }
  .APIConfigIndex_authServerTitle__Fool9 {
    font-size: 1rem;
  }
  .APIConfigIndex_authServerDescription__Tjk23 {
    font-size: 0.775rem;
    line-height: 1.8;
  }
  .APIConfigIndex_createAuthButton__MLmYy {
    font-size: 0.775rem;
  }
  .APIConfigIndex_configsmainTital__IhsL- {
    text-align: center;
  }
  .APIConfigIndex_authEditorModal__ZPCjG {
    padding: 16px;
  }
  .APIConfigIndex_configEditorModal__lQ3MQ {
    padding: 16px;
  }
  .APIConfigIndex_createTemplateButton__2uRn0,
  .APIConfigIndex_viewAllTemplatesButton__zzvdp {
    margin: 0px;
  }
}

@media (max-width: 480px) {
  .APIConfigIndex_authServerTitle__Fool9 {
    font-size: 1rem;
    font-weight: 600;
  }
  .APIConfigIndex_authServerDescription__Tjk23 {
    font-size: 0.875rem;
    color: var(--dark-color);
  }
  .APIConfigIndex_authServerDescription__Tjk23 .APIConfigIndex_code__CGwop {
    font-size: 0.875rem;
    font-weight: 600;
  }
  .APIConfigIndex_extraInfo__8aTBB {
    font-size: 0.875rem;
  }
  .APIConfigIndex_infoIcon__nIMBZ .APIConfigIndex_tooltipText__xfqDO {
    transform: translateX(-96%);
    width: 240px;
    bottom: -65%;
  }
  .APIConfigIndex_tittleWrap__krEZ- {
    flex-direction: column;
  }
  .APIConfigIndex_configCardHeader__3lZsp {
    flex-wrap: wrap;
  }
  .APIConfigIndex_configCard__KUpMs {
    padding: 14px;
  }
  .APIConfigIndex_configInfo__d-nCN {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .APIConfigIndex_configId__I57eJ {
    font-size: 0.875rem;
    color: var(--dark-color);
    font-weight: 700;
  }
  .APIConfigIndex_configEndpoint__7Wxrs .APIConfigIndex_configUrl__GhAn9 {
    color: var(--dark-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/APIConfigIndex.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mEAAmE;EACnE,mCAAmC;EACnC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,wCAAwC;AACxC;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;;GAEG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,sDAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE,qDAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;;EAEhB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,2BAA2B;;EAE3B,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,4CAA4C;AAC5C;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;EACxB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* APIConfigIndex.module.css */\n\n.container {\n  width: 100%;\n  padding: 20px 0px;\n  min-height: 700px;\n}\n\n/* ========== AUTHORIZATION SERVER SECTION ========== */\n.authServerSection {\n  border: 2px solid #bbd8ff;\n  border-radius: 6px;\n  padding: 24px;\n  margin-bottom: 32px;\n  background: #d9e9ff;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.authServerSection:hover {\n  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n.authServerHeader {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.authServerTitle {\n  color: #1a1614;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.authServerDescription {\n  margin-bottom: 20px;\n  font-size: 0.875rem;\n  color: #5f6368;\n  line-height: 1.5;\n}\n\n.authServerDescription code {\n  background-color: #f1f3f4;\n  padding: 2px 6px;\n  border-radius: 6px;\n  font-family: \"Courier New\", monospace;\n  font-size: 0.813rem;\n  color: #ff32cc;\n}\n.extraInfo {\n  font-size: 13px;\n  color: var(--subheading);\n}\n.authServerCurrent {\n  background-color: #ffffff;\n  padding: 16px;\n  border-radius: 12px;\n  /* margin-bottom: 12px; */\n  border: 1px solid #ffe0b2;\n  transition: all 0.2s ease;\n}\n\n.authServerCurrent:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.authServerInfo {\n  margin-bottom: 12px;\n  color: #202124;\n  font-size: 0.875rem;\n  display: flex;\n  flex-direction: column;\n}\n.authServerInfo strong {\n  background: transparent;\n  background: transparent;\n  color: #333;\n  max-width: 100%;\n  padding-bottom: 20px;\n}\n\n.authServerActions {\n  display: inline-flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.authEditButton {\n  padding: 8px 20px;\n  background: var(--editBtn);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.authEditButton:hover {\n  background: var(--editHover);\n}\n\n.authDeleteButton {\n  padding: 8px 20px;\n  background: var(--deleteBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.authDeleteButton:hover {\n  background: var(--deleteHover);\n}\n\n.createAuthButton {\n  padding: 12px 24px;\n  /* background: linear-gradient(135deg, #ff9800 0%, #fb8c00 100%); */\n  background: var(--gradient-primary);\n  color: var(--white-color);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.createAuthButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 119, 255, 0.3);\n}\n\n/* ========== MODAL EDITORS ========== */\n.authEditorModal,\n.configEditorModal {\n  border: 1px solid #e8eaed;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 24px;\n  background: var(--white-color);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  transition: all 0.2s ease;\n}\n\n.authEditorModal {\n  border-left: 4px solid #ff9800;\n}\n\n.configEditorModal {\n  border-left: 4px solid #1a73e8;\n}\n\n.modalTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #202124;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #e8eaed;\n}\n\n.curlImportSection {\n  margin-bottom: 20px;\n}\n\n.curlToggleButton {\n  padding: 8px 16px;\n  background: #f1f3f4;\n  color: #328bff;\n  border: 2px solid #bbd8ff;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.813rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.curlToggleButton:hover {\n  background: rgb(187, 214, 255);\n  color: #202124;\n}\n\n.formGroup {\n  margin-bottom: 20px;\n}\n\n.formLabel {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #5f6368;\n  font-size: 0.875rem;\n  padding: 20px 0px;\n}\n\n.textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #dadce0;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  resize: vertical;\n  background: #f8f9fa;\n}\n\n.textarea:focus {\n  outline: none;\n  border-color: #1a73e8;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.selectInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #dadce0;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  background-color: white;\n  transition: all 0.2s ease;\n}\n\n.selectInput:focus {\n  outline: none;\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n.modalActions {\n  margin-top: 24px;\n  display: flex;\n  gap: 12px;\n  justify-items: flex-end;\n  flex-direction: row-reverse;\n}\n\n.saveButton {\n  padding: 10px 24px;\n  background: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.saveButton:hover {\n  background: var(--saveHover);\n}\n\n.cancelButton {\n  padding: 10px 24px;\n  background: lightgray;\n  color: #333;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.cancelButton:hover {\n  background: rgb(176, 176, 176);\n}\n\n/* ========== REGULAR CONFIGURATIONS SECTION ========== */\n/* .regularConfigsSection {\n  margin-top: 16px;\n} */\n\n.configsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  /* padding: 20px; */\n  /* background: white; */\n  border-radius: 12px;\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.configsTitle {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #202124;\n  margin: 0;\n}\n.configsmainTital {\n  text-align: left;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #202124;\n  margin-bottom: 15px;\n}\n.createConfigButton {\n  padding: 10px 24px;\n  background-color: var(--saveBtn);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.createConfigButton:hover {\n  background: var(--saveHover);\n}\n\n.configsList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.configCard {\n  background: var(--white-color);\n  border: 1px solid #e8eaed;\n  border-radius: 16px;\n  padding: 20px;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.configCard:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n  border-color: #dadce0;\n}\n\n.configCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.configInfo {\n  flex: 1;\n}\n\n.configId {\n  font-weight: 600;\n  color: #202124;\n  margin-bottom: 4px;\n  font-size: 0.875rem;\n  font-family: \"Courier New\", monospace;\n  background: #f1f3f4;\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 6px;\n}\n\n.configEndpoint {\n  font-size: 0.875rem;\n  margin-top: 6px;\n}\n\n.configUrl {\n  color: #5f6368;\n  font-family: \"Courier New\", monospace;\n}\n\n.configMethod {\n  color: #1a73e8;\n  font-weight: 600;\n  margin-left: 4px;\n}\n\n.configActions {\n  display: flex;\n  gap: 8px;\n}\n\n.editButton {\n  width: 40px;\n  height: 40px;\n  background: var(--editBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.editButton:hover {\n  background: var(--editHover);\n}\n\n.deleteButton {\n  width: 40px;\n  height: 40px;\n  background: var(--deleteBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.deleteButton:hover {\n  background: var(--deleteHover);\n}\n\n.configDetails {\n  /* margin-top: 16px; */\n  padding: 16px 0px;\n  /* border-top: 1px solid #e8eaed; */\n}\n\n.configSummary {\n  cursor: pointer;\n  color: #1a73e8;\n  font-weight: 500;\n  font-size: 0.95rem;\n  user-select: none;\n  display: inline-block;\n  transition: all 0.2s ease;\n}\n\n.configSummary:hover {\n  color: #1557b0;\n  text-decoration: underline;\n}\n\n.configPre {\n  font-size: 0.875rem;\n  white-space: pre-wrap;\n  background: #fff;\n  padding: 12px;\n  border-radius: 8px;\n  margin-top: 12px;\n  border: 1px solid #e8eaed;\n  overflow-x: auto;\n  font-family: \"Courier New\", monospace;\n  color: #202124;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.emptyState {\n  text-align: center;\n  padding: 60px 40px;\n  background: var(--white-color);\n  border: 1px solid #e2e2e2;\n  border-radius: 6px;\n  transition: border-color 0.2s ease;\n  width: 100%;\n  margin-bottom: 20px;\n  box-shadow: var(--shadow-md);\n}\n\n.emptyState p {\n  color: #5f6368;\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* ========== LOADING STATE ========== */\n.loadingContainer {\n  padding: 60px;\n  text-align: center;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.loadingSpinner {\n  display: inline-block;\n  width: 48px;\n  height: 48px;\n  border: 4px solid #f1f3f4;\n  border-top: 4px solid #1a73e8;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loadingText {\n  font-size: 16px;\n  color: #5f6368;\n  font-weight: 500;\n}\n\n/* ========== ANIMATIONS ========== */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.authEditorModal,\n.configEditorModal {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.configCard,\n.authServerCurrent {\n  animation: fadeIn 0.3s ease-out;\n}\n.customSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 30px;\n  cursor: pointer;\n}\n\n.customSelect::-ms-expand {\n  display: none;\n}\n\n.customSelect::-ms-expand {\n  display: none;\n}\n\n.selectWrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.selectIcon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #666;\n}\n\n/* Add to APIConfigIndex.module.css */\n.placeholderMessage {\n  padding: 60px 20px;\n  text-align: center;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px dashed #dee2e6;\n  margin: 20px 0;\n}\n\n.placeholderIcon {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 16px;\n}\n\n.placeholderMessage h4 {\n  font-size: 18px;\n  color: #333;\n  margin: 0 0 12px 0;\n}\n\n.placeholderMessage p {\n  font-size: 16px;\n  color: #495057;\n  margin: 0;\n}\n.tittleWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.tittleWrap span {\n  cursor: help;\n  color: rgb(102, 102, 102);\n  font-size: 14px;\n}\n\n.infoIcon {\n  margin-left: 10px;\n  cursor: help;\n  color: #666;\n  font-size: 14px;\n  position: relative;\n  display: inline-block;\n}\n\n/* Tooltip container */\n.infoIcon .tooltipText {\n  visibility: hidden;\n  width: 300px;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 1.4;\n\n  /* Position */\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  transform: translateX(-50%);\n\n  /* Animation */\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n/* Tooltip arrow */\n.infoIcon .tooltipText::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #333 transparent transparent transparent;\n}\n\n/* Show tooltip on hover */\n.infoIcon:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n}\n.createTemplateButton {\n  padding: 12px;\n  background-color: rgb(55, 151, 254);\n  color: white;\n  border: medium;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-right: 8px;\n}\n.viewAllTemplatesButton {\n  padding: 12px;\n  background-color: rgb(56, 161, 105);\n  color: white;\n  border: medium;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-right: 8px;\n}\n.actionsWrap {\n  margin-top: 20px;\n}\n\n/* Add these styles to your module.css */\n.curlImportSection {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.curlToggleButton {\n  /* Your existing button styles */\n  position: relative;\n  z-index: 1;\n}\n\n.curlOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.curlOverlayContent {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.curlOverlayClose {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.curlOverlayClose:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n/* ========== RESPONSIVE DESIGN ========== */\n@media (max-width: 768px) {\n  .container {\n    padding: 0px;\n    overflow-x: hidden;\n  }\n\n  .authServerSection {\n    padding: 16px 10px;\n  }\n  .authServerInfo {\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n  .configsHeader {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 16px;\n  }\n\n  .configCardHeader {\n    flex-direction: column-reverse;\n    align-items: flex-start;\n    align-items: end;\n  }\n\n  .configActions {\n    /* width: 100%; */\n    margin-bottom: 20px;\n  }\n\n  .editButton,\n  .deleteButton {\n    flex: 1;\n    text-align: center;\n  }\n\n  .authServerActions {\n    flex-direction: column;\n  }\n\n  .authEditButton,\n  .authDeleteButton {\n    width: 100%;\n    text-align: center;\n    padding: 8px 20px;\n    font-size: 0.745rem;\n  }\n\n  .modalActions {\n    flex-direction: column;\n  }\n\n  .saveButton,\n  .cancelButton {\n    width: 100%;\n    text-align: center;\n  }\n\n  .metadata {\n    flex-direction: column;\n    gap: 8px;\n  }\n  .actionsWrap {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n  }\n  .infoIcon .tooltipText {\n    transform: translateX(-100%);\n  }\n  .authServerTitle {\n    font-size: 1rem;\n  }\n  .authServerDescription {\n    font-size: 0.775rem;\n    line-height: 1.8;\n  }\n  .createAuthButton {\n    font-size: 0.775rem;\n  }\n  .configsmainTital {\n    text-align: center;\n  }\n  .authEditorModal {\n    padding: 16px;\n  }\n  .configEditorModal {\n    padding: 16px;\n  }\n  .createTemplateButton,\n  .viewAllTemplatesButton {\n    margin: 0px;\n  }\n}\n\n@media (max-width: 480px) {\n  .authServerTitle {\n    font-size: 1rem;\n    font-weight: 600;\n  }\n  .authServerDescription {\n    font-size: 0.875rem;\n    color: var(--dark-color);\n  }\n  .authServerDescription .code {\n    font-size: 0.875rem;\n    font-weight: 600;\n  }\n  .extraInfo {\n    font-size: 0.875rem;\n  }\n  .infoIcon .tooltipText {\n    transform: translateX(-96%);\n    width: 240px;\n    bottom: -65%;\n  }\n  .tittleWrap {\n    flex-direction: column;\n  }\n  .configCardHeader {\n    flex-wrap: wrap;\n  }\n  .configCard {\n    padding: 14px;\n  }\n  .configInfo {\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n  .configId {\n    font-size: 0.875rem;\n    color: var(--dark-color);\n    font-weight: 700;\n  }\n  .configEndpoint .configUrl {\n    color: var(--dark-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `APIConfigIndex_container__xsuCG`,
	"authServerSection": `APIConfigIndex_authServerSection__d8QmP`,
	"authServerHeader": `APIConfigIndex_authServerHeader__-DMpZ`,
	"authServerTitle": `APIConfigIndex_authServerTitle__Fool9`,
	"authServerDescription": `APIConfigIndex_authServerDescription__Tjk23`,
	"extraInfo": `APIConfigIndex_extraInfo__8aTBB`,
	"authServerCurrent": `APIConfigIndex_authServerCurrent__orUjp`,
	"authServerInfo": `APIConfigIndex_authServerInfo__KPnRT`,
	"authServerActions": `APIConfigIndex_authServerActions__Jc-5L`,
	"authEditButton": `APIConfigIndex_authEditButton__I-jeF`,
	"authDeleteButton": `APIConfigIndex_authDeleteButton__ARQgp`,
	"createAuthButton": `APIConfigIndex_createAuthButton__MLmYy`,
	"authEditorModal": `APIConfigIndex_authEditorModal__ZPCjG`,
	"configEditorModal": `APIConfigIndex_configEditorModal__lQ3MQ`,
	"modalTitle": `APIConfigIndex_modalTitle__oAamI`,
	"curlImportSection": `APIConfigIndex_curlImportSection__sYqgx`,
	"curlToggleButton": `APIConfigIndex_curlToggleButton__7z8+I`,
	"formGroup": `APIConfigIndex_formGroup__0FBvX`,
	"formLabel": `APIConfigIndex_formLabel__J-zq4`,
	"textarea": `APIConfigIndex_textarea__nfIVY`,
	"selectInput": `APIConfigIndex_selectInput__WgR71`,
	"modalActions": `APIConfigIndex_modalActions__vNI8q`,
	"saveButton": `APIConfigIndex_saveButton__Feifq`,
	"cancelButton": `APIConfigIndex_cancelButton__BQJRE`,
	"configsHeader": `APIConfigIndex_configsHeader__PydBO`,
	"configsTitle": `APIConfigIndex_configsTitle__OysUS`,
	"configsmainTital": `APIConfigIndex_configsmainTital__IhsL-`,
	"createConfigButton": `APIConfigIndex_createConfigButton__klZ5p`,
	"configsList": `APIConfigIndex_configsList__dgDh5`,
	"configCard": `APIConfigIndex_configCard__KUpMs`,
	"configCardHeader": `APIConfigIndex_configCardHeader__3lZsp`,
	"configInfo": `APIConfigIndex_configInfo__d-nCN`,
	"configId": `APIConfigIndex_configId__I57eJ`,
	"configEndpoint": `APIConfigIndex_configEndpoint__7Wxrs`,
	"configUrl": `APIConfigIndex_configUrl__GhAn9`,
	"configMethod": `APIConfigIndex_configMethod__0OnRy`,
	"configActions": `APIConfigIndex_configActions__iJsCb`,
	"editButton": `APIConfigIndex_editButton__5W91a`,
	"deleteButton": `APIConfigIndex_deleteButton__+a+sX`,
	"configDetails": `APIConfigIndex_configDetails__A4+T3`,
	"configSummary": `APIConfigIndex_configSummary__BJ4Ya`,
	"configPre": `APIConfigIndex_configPre__djU1h`,
	"emptyState": `APIConfigIndex_emptyState__9P0OY`,
	"loadingContainer": `APIConfigIndex_loadingContainer__QF+z5`,
	"loadingSpinner": `APIConfigIndex_loadingSpinner__4IIxc`,
	"spin": `APIConfigIndex_spin__rlxEY`,
	"loadingText": `APIConfigIndex_loadingText__yVqjY`,
	"slideIn": `APIConfigIndex_slideIn__HaXP0`,
	"fadeIn": `APIConfigIndex_fadeIn__NBSde`,
	"customSelect": `APIConfigIndex_customSelect__jUZhd`,
	"selectWrapper": `APIConfigIndex_selectWrapper__9-leH`,
	"selectIcon": `APIConfigIndex_selectIcon__f0Onz`,
	"placeholderMessage": `APIConfigIndex_placeholderMessage__HNoE-`,
	"placeholderIcon": `APIConfigIndex_placeholderIcon__Wbd0l`,
	"tittleWrap": `APIConfigIndex_tittleWrap__krEZ-`,
	"infoIcon": `APIConfigIndex_infoIcon__nIMBZ`,
	"tooltipText": `APIConfigIndex_tooltipText__xfqDO`,
	"createTemplateButton": `APIConfigIndex_createTemplateButton__2uRn0`,
	"viewAllTemplatesButton": `APIConfigIndex_viewAllTemplatesButton__zzvdp`,
	"actionsWrap": `APIConfigIndex_actionsWrap__FI1+d`,
	"curlOverlay": `APIConfigIndex_curlOverlay__K2ITb`,
	"curlOverlayContent": `APIConfigIndex_curlOverlayContent__r2GPG`,
	"curlOverlayClose": `APIConfigIndex_curlOverlayClose__Unj8F`,
	"metadata": `APIConfigIndex_metadata__DjElj`,
	"code": `APIConfigIndex_code__CGwop`
};
export default ___CSS_LOADER_EXPORT___;
